module.exports = __webpack_public_path__ + "devicon.29f80b00a7b4641183f9.ttf";


//////////////////
// WEBPACK FOOTER
// /home/munkhuu/Desktop/mum/CS572/resume/src/assets/devicons/fonts/devicon.ttf?-hdf3wh
// module id = ../../../../../src/assets/devicons/fonts/devicon.ttf?-hdf3wh
// module chunks = styles